module.exports = __webpack_public_path__ + "img/duigou.1fc643f9.png";